// extracted by css-extract-rspack-plugin
export default {"codeTag":"gORRVmQnMQckEO1n","inlineBlock":"JUrISHBhvzgcmV9I"};